import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT


//获取列表数据
export const listData = (params) => {
  return axios.post(root + '/warehouse/jxcstoregoodsbarcode/list', qs.stringify(params))
}
export const listSimp = (params) => {
  return axios.post(root + '/warehouse/jxcstoregoodsbarcode/listSimp', qs.stringify(params))
}
export const updateouttime= (params) => {
  return axios.post(root + '/warehouse/jxcstoregoodsbarcode/updateouttime', qs.stringify(params))
}
//唯一码列表数据
export const weiyimalist = (params) => {
  return axios.post(root + '/warehouse/jxcstoregoodsbarcode/weiyimalist', qs.stringify(params))
}
//按订单号查询扫码记录(填写入库单判断是否已有扫码数据)
export const listByInordernum = (params) => {
  return axios.post(root + '/warehouse/jxcstoregoodsbarcode/listByInordernum', qs.stringify(params))
}
//删除行
export const deleteData = (params) => {
  return axios.post(root + '/warehouse/jxcstoregoodsbarcode/remove', qs.stringify(params))
}

//根据库存商品唯一条码获取某一行的明细数据
export const getDetail = (params) => {
  return axios.post(root + '/warehouse/jxcstoregoodsbarcode/detail', qs.stringify(params))
}
export const detailStoregoodsbarcode= (params) => {
  return axios.post(root + '/warehouse/jxcstoregoodsbarcode/detailStoregoodsbarcode', qs.stringify(params))
}
//批量保存
export const batchSave = (params) => {
  return axios.post(root + '/warehouse/jxcstoregoodsbarcode/batchSave', qs.stringify(params))
}
//保存某一行的数据
export const saveBarCodeData = (params) => {
  if (params.unitguid) {//修改
    return axios.post(root + '/warehouse/jxcstoregoodsbarcode/update', qs.stringify(params))
  } else {//添加
    return axios.post(root + '/warehouse/jxcstoregoodsbarcode/save', qs.stringify(params))
  }
}






// WEBPACK FOOTER //
// ./src/api/set/jxcstoregoodsbarcode.js